import { Component, HostListener, OnDestroy, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { Observable, Subscription } from "rxjs";
import { ReleaseNote } from "src/app/model/release-note";
import { AppState } from "src/app/store/app.reducer";
import { selectPrivacyNoteList } from "src/app/store/user/user.selector";
import { StandardPageLayout } from "../../stdlayoutlib/classes.stdlayoutlib";
import { RELEASE_PRIVACY_NOTES_VIEW } from "src/app/model/user";
import * as UserActions from 'src/app/store/user/user.actions';

@Component({
	templateUrl: './privacy-note.dialog.component.html',
})
export class PrivacyNoteDialogComponent implements OnInit, OnDestroy {

	privacyNoteList?: ReleaseNote[];
	privacyNoteList$: Observable<ReleaseNote[]>;
	privacyNoteListSub?: Subscription;

	limitedList: boolean;
	activeIndex: number;

	// design
	screenWidth: number;

	constructor(
		private store: Store<AppState>,
		private ref: DynamicDialogRef,
	) {
		this.initSelectors();
	}

	initSelectors(): void {
		this.privacyNoteList$ = this.store.select(selectPrivacyNoteList);
	}

	ngOnInit(): void {
		// we need to do a new dispatch GET api after home.component (or others main components) because we need to empty list
		this.store.dispatch(UserActions.getPrivacyNoteList({ size: RELEASE_PRIVACY_NOTES_VIEW }));

		this.privacyNoteListSub = this.privacyNoteList$
			.subscribe(privacyNoteList => {
				this.privacyNoteList = privacyNoteList;
			}
		);

		this.limitedList = true;
		this.activeIndex = 0;
	}

	closeDialog(): void {
		/*if (this.privacyNoteList !== undefined && this.privacyNoteList.length > 0) {
			this.store.dispatch(UserActions.setFePrivacyVersion({ version: this.privacyNoteList[0].ReleaseVersion }));
		}*/
		this.ref.close();
	}

	ngOnDestroy(): void {
		this.privacyNoteListSub?.unsubscribe();
	}

	expandAll() {
		this.store.dispatch(UserActions.getPrivacyNoteList({}));
		this.limitedList = false;
		this.activeIndex = -1;
	}

	collapseAll() {
		this.privacyNoteList = this.privacyNoteList.slice(0,RELEASE_PRIVACY_NOTES_VIEW);
		this.limitedList = true;
		this.activeIndex = 0;
	}

	// Design
	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile() {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}
}